var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterestWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.11684181137297855 500 500.116841811373",
    width: 500,
    height: 501,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "P-Badge-White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m157.2 482.1c-3.1-28.5-0.9-55.7 5.3-81.9l25-107.8c-4.1-13.1-7.2-28.1-7.2-43.1 0-35 16.9-60 43.5-60 18.4 0 31.8 12.8 31.8 37.5 0 7.8-1.5 16.5-4.7 26.5l-10.9 36c-2.2 6.8-3.1 13.4-3.1 19 0 25 19 39.1 43.4 39.1 43.4 0 74.4-45 74.4-103.5 0-65-42.5-106.5-105.3-106.5-70 0-114.4 45.6-114.4 109 0 25.7 7.8 49.4 23.1 65.7-5 8.4-10.3 10-18.4 10-25 0-48.8-35.3-48.8-83.5 0-83.1 66.6-149.3 160-149.3 98.2 0 159.7 68.4 159.7 152.8 0 85-60 148.7-124.7 148.7-25.6 0-48.1-10.9-63.7-30.6l-12.8 51.9c-6.9 26.8-17.2 52.2-33.8 76.5 23.5 7.2 46.6 11.3 74.4 11.3 138.1 0 250-111.9 250-250 0-138.1-111.9-250-250-250-138.1 0-250 111.9-250 250 0 104.7 64.4 195 157.2 232.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestWhite);
export default __webpack_public_path__ + "static/media/pinterest_white.255c1e37657cfffe2726c80c96939173.svg";
export { ForwardRef as ReactComponent };